import t from "../../theme";

export const useGetAppModalStyles = () => {
  return {
    paper: {
      position: "relative",
      width: "100%",
      borderRadius: t.radius.lg,
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      border: t.border.base,
      boxShadow: t.shadow.lg,
      overflow: "hidden",
    },
    accent: {
      height: "4px",
      width: "100%",
      background: t.green.gradient,
    },
    overlay: {
      position: "absolute",
      top: "14px",
      right: "14px",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    closeButton: {
      background: t.glass.heavy,
      boxShadow: t.shadow.sm,
      color: t.text.secondary,
      "&:hover": {
        background: t.glass.heavy,
        color: t.text.primary,
      },
    },
    content: {
      padding: "32px",
      paddingTop: "56px",
    },
  };
};
